import { Form, Select } from "antd";

import { useUsers } from "../../data/use-users";
import { filterOption } from "./filter-option";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { getSelectOptions } from "../../utils/get-select-options";

export const UserSelect = (props) => {
  const users = useUsers();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        placeholder="Select a sales rep"
        optionFilterProp="children"
        filterOption={filterOption}
        options={getSelectOptions({
          store: users,
          initialIds: initialValue,
          labelKey: "alias",
          labelKeyMap: props.labelKeyMap,
          includeArchived: props.includeArchived ?? false,
          groupBy: props.groupBy,
        })}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
